export const SLICE = 'ui';

export const PUSH_ROUTE = `${SLICE}/PUSH_ROUTE`;

export const ADD_NOTIFICATION = `${SLICE}/ADD_NOTIFICATION`;
export const CLOSE_NOTIFICATION = `${SLICE}/CLOSE_NOTIFICATION`;

export const START_REQUEST_LOADING = `${SLICE}/START_REQUEST_LOADING`;
export const END_REQUEST_LOADING = `${SLICE}/END_REQUEST_LOADING`;

export const UI_MODAL = 'UI_MODAL';
export const OPEN_UI_MODAL = `${SLICE}/OPEN_${UI_MODAL}`;
export const CLOSE_UI_MODAL = `${SLICE}/CLOSE_${UI_MODAL}`;

export const UPLOAD_FILES_MODAL = 'UPLOAD_FILES_MODAL';
export const FOLDER_CREATE_MODAL = 'FOLDER_CREATE_MODAL';
export const DELETE_REPORT_MODAL = 'DELETE_REPORT_MODAL';
export const UPLOAD_REPORT_MODAL = 'UPLOAD_REPORT_MODAL';
export const APPROVE_REPORT_MODAL = 'APPROVE_REPORT_MODAL';
export const REJECT_REPORT_MODAL = 'REJECT_REPORT_MODAL';

export const NotificationTypeEnum = Object.freeze({
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
});

export const DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
export const POLLING_NOTIFICATION_CLOSE_TIMEOUT = 10000;
export const DEFAULT_ROUTE_CHANGE_TIMEOUT = 5000;

export interface Notification {
  id: string;
  type: string;
  title: string;
  timeout: number;
}

export interface UIReducerProps {
  notifications: Notification[];
  pendingRequests: Array<string>;
  openedModal: { type: string; payload: any };
  form: {};
  currentSelectedTab: string;
}

export interface UIReducerStateProps {
  [id: string]: UIReducerProps;
}

export const FORM = 'FORM';
export const UPDATE_FORM_VALUE = `${SLICE}/UPDATE_${FORM}`;
export const RESET_FORM_VALUES = `${SLICE}/RESET_${FORM}`;

export const TAB_VALUE = 'TAB_VALUE';
export const UPDATE_TAB_VALUE = `${SLICE}/UPDATE_${TAB_VALUE}`;
export const GET_TAB_VALUE = `${SLICE}/GET_${TAB_VALUE}`;
